import { useMemo } from 'react';
import objectPath from 'object-path';

import { useHtmlClassService } from '_metronic/layout/_core/MetronicLayout';
import { QuickUserToggler } from '_metronic/layout/components/extras/QuickUserToggler';

export function Topbar() {
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(
    () => ({ viewUserDisplay: objectPath.get(uiService.config, 'extras.user.display') }),
    [uiService]
  );

  return layoutProps.viewUserDisplay ? <QuickUserToggler /> : null;
}
